import { Avatar, Box, Paper, Typography, useTheme } from '@mui/material'
import { colors } from 'constants/colors'
import React from 'react'

interface FeatureCardProps {
  icon: React.ReactNode
  title: string
  description: string
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description }) => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'

  return (
  <Paper
    elevation={2}
    sx={{
      flex: 1,
      p: { xs: 1.75, sm: 2.25 },
      borderRadius: 3,
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      backgroundColor: isDark ? colors.ALMOST_BLACK : colors.WHITE,
      backgroundImage: 'none',
      transition: 'box-shadow 0.2s',
      '&:hover': { boxShadow: 6 },
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      <Avatar
        sx={{
          bgcolor: `${colors.MOONSTONE}22`,
          color: colors.MOONSTONE,
          width: 36,
          height: 36,
          flexShrink: 0,
          '& svg': { fontSize: '1.15rem' },
        }}
      >
        {icon}
      </Avatar>
      <Typography fontFamily='PremierLeagueBold' fontSize={{ xs: '0.8rem', sm: '0.9rem' }} lineHeight={1.25}>
        {title}
      </Typography>
    </Box>
    <Typography
      fontFamily='PremierLeagueBold'
      fontSize={{ xs: '0.75rem', sm: '0.8rem' }}
      sx={{ lineHeight: 1.55, opacity: 0.7, color: 'text.primary' }}
    >
      {description}
    </Typography>
  </Paper>
  )
}

export default FeatureCard
